import * as React from 'react';

function SvgCountdown(props) {
  return (
    <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 2.834c0 .72.87 1.08 1.378.571L3.19 1.592A.807.807 0 002.62.214h-.001a.806.806 0 00-.571.237L.237 2.262a.806.806 0 00-.237.57v.002zm12 0c0 .72-.87 1.08-1.378.571L8.81 1.592A.807.807 0 019.38.214h.001c.215 0 .42.085.571.237l1.811 1.811a.806.806 0 01.237.57v.002zm-6-.477a4.714 4.714 0 110 9.429 4.714 4.714 0 010-9.429zM6 4a.5.5 0 00-.5.5v2.571l.008.09a.5.5 0 00.18.3L7.83 9.177l.075.05a.5.5 0 00.627-.128l.05-.075a.5.5 0 00-.128-.628L6.5 6.83V4.5l-.008-.09A.5.5 0 006 4z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCountdown;
